var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import RegexStr from "../../common/RegexStr";
import CommonService from "../../api/CommonService";
import { ESendCodeType } from "../../enum/ESendCodeType";
import { CachePocily } from "../../common/Cache";
import { ECache } from '../../enum/ECache';
import CACHE_KEY from '../../constant/cacheKey';
var phoneRegex = new RegExp(RegexStr.mobile);
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.formData = {
            phone: '',
            sms_code: '',
        };
        _this.supplierList = [];
        _this.supplierRoleList = [];
        _this.canGetCode = true;
        _this.remainTime = 60;
        _this.timer = null;
        _this.phone = [];
        return _this;
    }
    List.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        var infor = this.cache.getData(CACHE_KEY.LOGIN);
        var loginForm = JSON.parse(infor.userInfo);
        this.phone = loginForm.account_name || loginForm.phone;
    };
    List.prototype.sendCode = function () {
        var _this = this;
        console.log('phone=============', this.phone);
        if (this.timer)
            return;
        if (!phoneRegex.test(this.phone)) {
            this.$message.error('手机号格式不正确！');
            return;
        }
        this.commonService.sendCode({ phone: this.phone, type: ESendCodeType.smsBusinessDelete }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
        this.canGetCode = false;
        this.timer = setInterval(function () {
            _this.remainTime--;
            if (_this.remainTime === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    List.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    List.prototype.close = function () {
        this.$closeDialog();
    };
    List.prototype.save = function () {
        this.$emit('artMsglist:ok', this.formData.sms_code);
    };
    List = __decorate([
        Component
    ], List);
    return List;
}(VueDialog));
export default List;
